/* PQ zoom viewer: replaces Dawn lightbox. Fit-to-viewport, click/wheel/pinch zoom, pan, prev/next, thumbs. No observers. */
(function () {
  var MAX = 2.5, CLICK_Z = 2.5;
  var ICON = function (d) { return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; };
  var root, stage, img, strip, counter, items = [], idx = 0, lastFocus;
  var s = 1, tx = 0, ty = 0, bx = 0, by = 0, bw = 0, bh = 0, sw = 0, sh = 0;
  var ptrs = {}, drag = null, pinch = null, moved = false, lastTap = 0;

  function hi(u) { u = (u || '').replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=2400'; }
  function collect() {
    var lis = Array.prototype.slice.call(document.querySelectorAll('.product__media-list > li.product__media-item'));
    return lis.filter(function (li) { return !!li.querySelector('img'); }).map(function (li) {
      var im = li.querySelector('.product__media img') || li.querySelector('img');
      return { li: li, src: hi(im.currentSrc || im.src), thumb: im.src.replace(/width=\d+/, 'width=160'), alt: im.alt || '' };
    });
  }
  function build() {
    root = document.createElement('div');
    root.className = 'pq-zoom'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product images'); root.hidden = true;
    root.innerHTML = '<div class="pq-zoom__stage"><img class="pq-zoom__img" alt="" draggable="false"></div>' +
      '<button type="button" class="pq-zoom__close product-media-modal__toggle" aria-label="Close">' + ICON('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>') + '</button>' +
      '<button type="button" class="pq-zoom__nav pq-zoom__nav--prev" aria-label="Previous image">' + ICON('<path d="m15 18-6-6 6-6"/>') + '</button>' +
      '<button type="button" class="pq-zoom__nav pq-zoom__nav--next" aria-label="Next image">' + ICON('<path d="m9 18 6-6-6-6"/>') + '</button>' +
      '<div class="pq-zoom__counter" aria-live="polite"></div><div class="pq-zoom__strip"></div>';
    document.body.appendChild(root);
    stage = root.querySelector('.pq-zoom__stage'); img = root.querySelector('.pq-zoom__img');
    strip = root.querySelector('.pq-zoom__strip'); counter = root.querySelector('.pq-zoom__counter');
    var cb = root.querySelector('.pq-zoom__close'); cb.addEventListener('click', close);
    cb.addEventListener('pointerdown', function () { cb._d = 1; }); cb.addEventListener('pointerup', function (e) { if (cb._d && e.pointerType !== 'mouse') close(); cb._d = 0; });
    root.querySelector('.pq-zoom__nav--prev').addEventListener('click', function () { go(idx - 1); });
    root.querySelector('.pq-zoom__nav--next').addEventListener('click', function () { go(idx + 1); });
    strip.addEventListener('click', function (e) { var b = e.target.closest('button[data-i]'); if (b) go(+b.dataset.i); });
    img.addEventListener('load', layout);
    stage.addEventListener('wheel', onWheel, { passive: false });
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('click', onClick);
    window.addEventListener('resize', function () { if (!root.hidden) layout(); });
  }
  function layout() {
    var r = stage.getBoundingClientRect(); sw = r.width; sh = r.height;
    var nw = img.naturalWidth || 1, nh = img.naturalHeight || 1, k = Math.min(sw / nw, sh / nh);
    bw = nw * k; bh = nh * k; bx = (sw - bw) / 2; by = (sh - bh) / 2;
    img.style.width = bw + 'px'; img.style.height = bh + 'px'; img.style.left = bx + 'px'; img.style.top = by + 'px';
    reset(false);
  }
  function apply(anim) {
    img.classList.toggle('is-anim', !!anim);
    img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    root.classList.toggle('is-zoomed', s > 1.01);
  }
  function clamp() {
    var W = bw * s, H = bh * s;
    tx = W <= sw ? (sw - W) / 2 - bx : Math.min(-bx, Math.max(sw - bx - W, tx));
    ty = H <= sh ? (sh - H) / 2 - by : Math.min(-by, Math.max(sh - by - H, ty));
  }
  function zoomTo(ns, px, py, anim) {
    ns = Math.max(1, Math.min(MAX, ns));
    var ux = (px - bx - tx) / s, uy = (py - by - ty) / s;
    s = ns; tx = px - bx - ux * s; ty = py - by - uy * s; clamp(); apply(anim);
  }
  function reset(anim) { s = 1; tx = 0; ty = 0; apply(anim); }
  function local(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function onWheel(e) {
    e.preventDefault();
    var p = local(e), f = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.002));
    zoomTo(s * f, p.x, p.y, false);
  }
  function onDown(e) {
    if (e.button && e.button !== 0) return;
    ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(ptrs); moved = false;
    if (ids.length === 2) {
      var a = ptrs[ids[0]], b = ptrs[ids[1]], r = stage.getBoundingClientRect();
      pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: s, cx: (a.x + b.x) / 2 - r.left, cy: (a.y + b.y) / 2 - r.top }; drag = null;
    } else { drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, t: Date.now() }; }
    img.classList.remove('is-anim');
  }
  function onMove(e) {
    if (!ptrs[e.pointerId]) return;
    ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(ptrs);
    if (pinch && ids.length >= 2) {
      var a = ptrs[ids[0]], b = ptrs[ids[1]]; moved = true;
      zoomTo(pinch.s * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, pinch.cx, pinch.cy, false); return;
    }
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
    if (s > 1.01) { tx = drag.tx + dx; ty = drag.ty + dy; clamp(); apply(false); root.classList.add('is-dragging'); }
  }
  function onUp(e) {
    var d = drag; delete ptrs[e.pointerId]; root.classList.remove('is-dragging');
    if (pinch) { if (Object.keys(ptrs).length < 2) { pinch = null; drag = null; if (s < 1.05) reset(true); } return; }
    drag = null;
    if (d && s <= 1.01 && e.pointerType !== 'mouse') {
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) { go(idx + (dx < 0 ? 1 : -1)); moved = true; }
    }
  }
  function onClick(e) {
    if (moved) { moved = false; return; }
    var ib = img.getBoundingClientRect(); if (s <= 1.01 && (e.clientX < ib.left || e.clientX > ib.right || e.clientY < ib.top || e.clientY > ib.bottom)) return;
    if (e.detail > 1) return; /* second click of a double-click: already toggled */
    var p = local(e);
    if (e.pointerType === 'touch' || (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents)) {
      var now = Date.now(); if (now - lastTap > 320) { lastTap = now; return; } lastTap = 0; /* double-tap toggles */
    }
    if (s > 1.01) reset(true); else zoomTo(CLICK_Z, p.x, p.y, true);
  }
  function renderStrip() {
    strip.innerHTML = items.map(function (it, i) { return '<button type="button" data-i="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + it.thumb + '" alt="" loading="lazy"></button>'; }).join('');
  }
  function go(i) {
    if (!items.length) return;
    idx = (i + items.length) % items.length;
    var it = items[idx];
    reset(false); img.removeAttribute('style'); img.alt = it.alt; img.src = it.src;
    if (img.complete && img.naturalWidth) layout();
    counter.textContent = (idx + 1) + ' / ' + items.length;
    Array.prototype.forEach.call(strip.children, function (b, j) { b.classList.toggle('is-active', j === idx); if (j === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    var ab = strip.children[idx]; if (ab) strip.scrollLeft = ab.offsetLeft - (strip.clientWidth - ab.offsetWidth) / 2;
    root.classList.toggle('is-single', items.length < 2);
  }
  function open(li) {
    if (!root) build();
    items = collect(); if (!items.length) return;
    var start = 0; items.forEach(function (it, i) { if (it.li === li) start = i; });
    lastFocus = document.activeElement; renderStrip();
    root.hidden = false; document.documentElement.classList.add('pq-zoom-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); go(start); root.querySelector('.pq-zoom__close').focus({ preventScroll: true }); });
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open'); root.hidden = true; img.removeAttribute('src');
    document.documentElement.classList.remove('pq-zoom-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('.product__modal-opener--image');
    if (!op || !op.closest('.product__media-list')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(op.closest('li.product__media-item'));
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!root || root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    else if (e.key === 'Tab') { var f = root.querySelectorAll('button'); var first = f[0], last = f[f.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } }
  });
  window.pqZoom = { open: open, close: close, state: function () { return { s: s, tx: tx, ty: ty, idx: idx, n: items.length, open: !!root && !root.hidden }; } };
})();
